<script>
	import { onMount } from "svelte";
	import { fadeIn } from "@pernod-ricard-global-cms/jsanimations";
	onMount(() => {
		const bannerTitle = document.querySelector(".banner__title");
		setTimeout(() => {
			fadeIn(bannerTitle, 1000);
		}, 1000);
	});
	export let bannerTitle = "Banner title";
</script>

<section class="banner">
	<h1 class="banner__title">{bannerTitle}</h1>
</section>

<style lang="scss">
	@use "./styles/mixins";

	.banner {
		display: grid;
		text-align: center;
		place-items: center;
		min-height: 200px;

		&__title {
			font-size: 40px;
			line-height: 1;
			opacity: 0;
			background-image: url("/images/fire.webp");
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-position: center;
			@include mixins.device(768px) {
				font-size: 80px;
			}
		}
	}
</style>
